const columns = [
  {
    title: '深扒栏目',
    links: [
      { label: '深扒速览', href: '#feed' },
      { label: '话题墙', href: '#topics' },
      { label: '时间线还原', href: '#timeline' },
      { label: '逐层拆解', href: '#layers' },
    ],
  },
  {
    title: '热门话题',
    links: [
      { label: '长图深扒', href: '#topics' },
      { label: '多图对比', href: '#topics' },
      { label: '聊天记录', href: '#topics' },
      { label: '幕后关联', href: '#topics' },
    ],
  },
  {
    title: '互动',
    links: [
      { label: '评论区讨论', href: '#community' },
      { label: '深扒热榜', href: '#feed' },
      { label: '开启提醒', href: '#subscribe' },
      { label: '内容说明', href: '#top' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-100">
      <div className="px-4 md:px-6 lg:px-10 pt-12 md:pt-14 pb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
                黑
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料图文</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-900 max-w-md font-body">
              黑料图文深扒解析栏目，用长图与多图对比拆解事件细节。从聊天记录到公开动态逐层还原，
              一次看清黑料图文内幕全貌。站内内容均为公开信息的图文整理与时间线梳理。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              {['长图深扒', '时间线还原', '多图对比'].map((t) => (
                <span key={t} className="h-7 px-3 inline-flex items-center rounded-full bg-secondary-200 text-secondary-900 text-xs font-label whitespace-nowrap">
                  {t}
                </span>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                <a href="#top" className="hover:text-primary-600 transition-colors">{col.title}</a>
              </h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm text-secondary-900 hover:text-primary-600 transition-colors whitespace-nowrap font-label">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1"></div>
        </div>

        <div className="mt-10 pt-5 border-t border-secondary-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-900 font-label">© 2026 黑料图文 · 深扒长图与图文解析存档</p>
          <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-secondary-900 font-label">
            <a href="#top" className="hover:text-primary-600 transition-colors">回到顶部</a>
            <a href="#community" className="hover:text-primary-600 transition-colors">参与讨论</a>
            <span>内容仅供图文整理与时间线核对</span>
          </div>
        </div>
      </div>
    </footer>
  );
}